import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

// Lazy load route components
const PartnerNetworkDashboard = React.lazy(
  () =>
    import(
      "../../modules/partnerNetwork/features/PartnerNetworkDashboard/PartnerNetworkDashboard"
    ),
);

const PartnerManagement = React.lazy(
  () =>
    import(
      "../../modules/partnerNetwork/features/PartnerManagement/PartnerManagement"
    ),
);

const PartnerDetail = React.lazy(() =>
  import(
    "../../modules/partnerNetwork/features/PartnerManagement/components/PartnerDetail"
  ).then((module) => ({ default: module.PartnerDetail })),
);

const PartnerForm = React.lazy(() =>
  import(
    "../../modules/partnerNetwork/features/PartnerManagement/components/PartnerForm"
  ).then((module) => ({ default: module.PartnerForm })),
);

const ReportsAndAnalytics = React.lazy(
  () =>
    import(
      "../../modules/partnerNetwork/features/ReportsAndAnalytics/ReportsAndAnalytics"
    ),
);

const MemberRebatesPage = React.lazy(() =>
  import("../../modules/partnerNetwork/features/MemberRebates").then(
    (module) => ({ default: module.MemberRebatesPage }),
  ),
);

const MembersList = React.lazy(() =>
  import(
    "../../modules/partnerNetwork/features/MemberManagement/components/MembersList"
  ).then((module) => ({ default: module.MembersList })),
);

const MemberDetail = React.lazy(() =>
  import(
    "../../modules/partnerNetwork/features/MemberManagement/components/MemberDetail"
  ).then((module) => ({ default: module.MemberDetail })),
);

const ReportValidationView = React.lazy(() =>
  import(
    "../../modules/partnerNetwork/features/PartnerManagement/components/reports/ReportValidationView"
  ).then((module) => ({ default: module.ReportValidationView })),
);

// Create stable component reference
const PartnerNetworkMainLayout = () => <MainLayout section="partnerNetwork" />;

const PartnerNetworkRoutes = (
  <Route
    element={<AuthenticationGuard component={PartnerNetworkMainLayout} />}
    path="/partner-network"
  >
    {/* Dashboard - Main landing page */}
    <Route element={<PartnerNetworkDashboard />} index />

    {/* Partner Management Routes */}
    <Route element={<PartnerManagement />} path="partners" />

    <Route element={<PartnerForm />} path="partners/new" />

    <Route element={<PartnerDetail />} path="partners/:id" />

    <Route element={<PartnerForm />} path="partners/:id/edit" />

    {/* Member Registration Management Routes */}
    {/* <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_MANAGE_REGISTRATIONS"]}>
          <MemberRegistrationManagement />
        </PermissionGuard>
      }
      path="registrations"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_MANAGE_REGISTRATIONS"]}>
          <MemberRegistrationManagement />
        </PermissionGuard>
      }
      path="partners/:partnerId/registrations"
    />

    {/* Quarter Status Management Routes */}
    {/* <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <QuarterStatusManagement />
        </PermissionGuard>
      }
      path="quarter-status"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <QuarterStatusManagement />
        </PermissionGuard>
      }
      path="partners/:partnerId/quarter-status"
    />

    {/* Transaction Management Routes */}
    {/* <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <TransactionManagement />
        </PermissionGuard>
      }
      path="transactions"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <TransactionManagement />
        </PermissionGuard>
      }
      path="partners/:partnerId/transactions"
    />

    {/* Members Management Routes */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <MembersList />
        </PermissionGuard>
      }
      path="members"
    />

    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <MemberDetail />
        </PermissionGuard>
      }
      path="members/:id"
    />

    {/* Member Rebates Routes */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <MemberRebatesPage />
        </PermissionGuard>
      }
      path="member-rebates"
    />

    {/* Reports and Analytics Routes */}
    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <ReportsAndAnalytics />
        </PermissionGuard>
      }
      path="reports"
    />

    <Route element={<ReportValidationView />} path="reports/:id" />

    <Route
      element={
        <PermissionGuard requiredPermissions={["PARTNER_VIEW"]}>
          <ReportsAndAnalytics />
        </PermissionGuard>
      }
      path="partners/:partnerId/reports"
    />

    {/* Administrative Routes */}
    {/* <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_PARTNER_ADMIN"]}>
          <PartnerManagement />
        </PermissionGuard>
      }
      path="admin/partners"
    />

    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_PARTNER_ADMIN"]}>
          <ReportsAndAnalytics />
        </PermissionGuard>
      }
      path="admin/analytics"
    /> */}
  </Route>
);

export default PartnerNetworkRoutes;
